// import smoothScroll from 'smooth-scroll';
// let options = { 
//   speed: 500,
//   offset: window.innerWidth >= 1024 ? 0 : 50
// };

// let scroll = new smoothScroll('a[href*="#"]', options);


// var hash = location.hash;

// if ($(hash).length > 0) {
//   $(window).scrollTop(0);
//   setTimeout(function () {
//     scroll.animateScroll(document.querySelector(target), options);
//   }, 700);
// }

$('a[href^="#"]').click(function () {
  var speed = 1500;　//スクロールスピード
  var href = $(this).attr("href");
  var target = $(href == "#" || href == "" ? 'html' : href);
  var position = target.offset().top;

  if(window.innerWidth <= 768) {
    var calc_position = position - 20;
  } else {
    var calc_position = position - 85;
  }
  $("html, body").animate({ scrollTop: calc_position }, speed, "swing");
  return false;
});
